<ng-content></ng-content>
<p [hidden]="hideErrorMessage || !(appFormControlWrap.invalid && appFormControlWrap.touched)" class="field__error-message">{{ getErrorMessage() }}</p>
